import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from "underscore";
import {Tag} from "antd";
import BukkuTooltip from "../Tooltip";

/**
 * Props:
 * - accountId: Number
 * - isTag: Boolean
 * - tagColor: String
 */

class TransactionAccount extends Component {
    shouldComponentUpdate(nextProps) {
        const { accountId, accounts } = this.props;
        if (accountId !== nextProps.accountId)
            return true;
        return !_.isEqual(accounts, nextProps.accounts);
    }

    getFlattenAccounts = accounts => accounts.flatMap(account => {
        if (!account.children)
            return [account];
        return [account, ...account.children];
    });

    getAccount(account_id) {
        const { accounts } = this.props;
        const flattenAccounts = this.getFlattenAccounts(accounts);
        return flattenAccounts.find(i => i.id === account_id);
    }

    renderContent = account => (
        <span>
            <strong>{account.code}</strong>
            &nbsp;
            { account.name }
        </span>
    );

    render() {
        const { accountId, isTag, tagColor } = this.props;
        const account = accountId ? this.getAccount(accountId) : null;
        if (!account)
            return '-';

        const content = this.renderContent(account);
        if (isTag) {
            return (
                <Tag color={tagColor}>
                    { content }
                </Tag>
            );
        }
        return (
            <BukkuTooltip title={content}>
                {content}
            </BukkuTooltip>
        );
    }
}

export default connect(state => ({
    accounts: state.List.accounts,
}), {

})(TransactionAccount);
